import React, { useState } from 'react';
import EntityCount from './EntityCount';

const CitywiseAnalytics = () => {
  return (
    <div>
      <EntityCount />
    </div>
  );
}

export default CitywiseAnalytics;
